import { render } from "./QuickMenu.vue?vue&type=template&id=07941a36&scoped=true"
import script from "./QuickMenu.vue?vue&type=script&lang=js"
export * from "./QuickMenu.vue?vue&type=script&lang=js"

import "./QuickMenu.vue?vue&type=style&index=0&id=07941a36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\source\\MFVK\\menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07941a36"]])

export default __exports__